import React,{useState,useEffect} from 'react'
import Template0 from './templates/Template0'
import Template1 from './templates/Template1'
import Template2 from './templates/Template2'
import Template3 from './templates/Template3'
import Template4 from './templates/Template4'
import Template5 from './templates/Template5'
import PageNotFound from './PageNotFound'
import Modal from './Modal'

export default function PreviewTemplate(props) {
	const [showModal,setShowModal]=useState(false)
	useEffect(()=>{
		setTimeout(()=>{
			setShowModal(true)
		},5000)
	},[])
	switch(props.match.params.id){
		case "0": return (<><Modal showModal={showModal} setShowModal={setShowModal}/><Template0/></>)
		case "1": return (<><Modal showModal={showModal} setShowModal={setShowModal}/><Template1/></>)
		case "2": return (<><Modal showModal={showModal} setShowModal={setShowModal}/><Template2/></>)
		case "3": return (<><Modal showModal={showModal} setShowModal={setShowModal}/><Template3/></>) 
		case "4": return (<><Modal showModal={showModal} setShowModal={setShowModal}/><Template4/></>)
		case "5": return (<><Modal showModal={showModal} setShowModal={setShowModal}/><Template5/></>)
		default : return <PageNotFound/>
	}
}